// Shared waiver/position gating + intro copy for the invite accept UI. Lives
// here (not in index.jsx) so both the regular invite card and the underage
// flow's final step reuse the exact same logic without a circular import.

interface DisableSubmitArgs {
  shouldDisplayWaiver?: boolean
  /** Accepted for call-site compatibility; gating uses the checkbox, not scroll. */
  hasScrolled?: boolean
  loading?: boolean
  ask_position?: boolean
  selectedPosition?: string | number | null
  acceptedWaiver?: boolean
}

/**
 * Whether the accept/Join button should be disabled. With a waiver, the button
 * stays disabled until the "I have read and agree" checkbox is checked. Without
 * a waiver, it is disabled while loading or while a required position is unset.
 */
export const disableSubmitButton = ({
  shouldDisplayWaiver = false,
  loading = false,
  ask_position = false,
  selectedPosition = null,
  acceptedWaiver = false,
}: DisableSubmitArgs): boolean => {
  if (shouldDisplayWaiver) {
    if (acceptedWaiver) {
      return false
    }
    return true
  }
  if (loading) {
    return true
  }
  if (ask_position && !selectedPosition) {
    return true
  }
  return false
}

/** Intro line above the waiver/position controls on the accept card. */
export const getText = (
  shouldDisplayWaiver = false,
  ask_position = false
): string => {
  if (shouldDisplayWaiver && ask_position) {
    return 'To accept this invitation, please choose your position and accept the waiver terms and conditions:'
  }
  if (shouldDisplayWaiver) {
    return 'To accept this invitation, please accept the waiver terms and conditions:'
  }
  if (ask_position) {
    return 'To accept this invitation, please choose your position:'
  }
  return ''
}
